import { apiRequest } from "@portal/lib/ky/utils";
import {
  ContactTypes,
  Contact_LV_UI_DTO,
  CreateContact,
} from "@portal/types/entities/contact";
import { PageList } from "@portal/types/page-list";

export async function createAContact(params: CreateContact) {
  const data = await apiRequest<CreateContact, Contact_LV_UI_DTO>({
    method: "POST",
    url: "v1/contacts",
    data: { ...params },
  });
  return await data.json();
}

export async function updateAContact(params: CreateContact, id?: string) {
  const data = await apiRequest<CreateContact, Contact_LV_UI_DTO>({
    method: "PUT",
    url: `v1/contacts/${id}`,
    data: { ...params },
  });
  return await data.json();
}

export async function deleteAContact(id?: string) {
  await apiRequest<undefined, undefined>({
    method: "DELETE",
    url: `v1/contacts/${id}`,
  });
}

export async function getContactTypes() {
  const data = await apiRequest<unknown, PageList<ContactTypes, undefined>>({
    method: "GET",
    url: "v1/contacts/types",
  });
  return await data.json();
}
